import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { BlockSpace } from 'components/atoms/space';
import { Divider, PlaceholderText } from '../styles';
import { ConditionTypes } from './types';

export const PlaceholderValues = ({
  placeholderFor,
  disabled,
  onVisibilityChange,
}: {
  placeholderFor: ConditionTypes;
  disabled?: boolean;
  onVisibilityChange: (visibility: boolean) => void;
}) => (
  <BlockSpace direction="vertical" size={16}>
    <PlaceholderText>
      {placeholderFor === ConditionTypes.Triggers ? (
        <FormattedMessage
          id="settings.integrations.sf.automation.create.trigger.placeholder"
          values={{
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      ) : (
        <FormattedMessage
          id="settings.integrations.sf.automation.create.matches.placeholder"
          values={{
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      )}
    </PlaceholderText>

    <LinkButton
      onClick={() => onVisibilityChange(true)}
      disabled={disabled}
      type="link"
    >
      <FormattedMessage id="edit" />
      ...
    </LinkButton>
    <Divider />
  </BlockSpace>
);
